import BaseApiAction from "@Actions/base-api-action";

export default class GetUser extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: "users-getUser",
      payload: this._payload
        ? {
            user_doc_id: this._payload.doc_id,
          }
        : {},
    });
  }
}
